import api from './api';

export interface WishlistPagination {
  total_records: number;
  total_pages: number;
  page_number: number;
  page_size: number;
}

export interface WishlistResponse {
  success: boolean;
  message?: string;
  data: any[];
  wishlistItems?: any[];
  allVehicleIds?: string[];
  pagination?: WishlistPagination;
}

export const getWishlist = async (params?: { page?: number; pageSize?: number; all?: boolean }) => {
  const res = await api.get('/customer/wishlist', { params });
  return res.data as WishlistResponse;
};

export const toggleWishlist = async (vehicleId: string | number) =>
  (await api.post('/customer/wishlist/toggle', { vehicleId })).data as {
    action: 'added' | 'removed';
  };

export const syncWishlist = async (vehicleIds: Array<string | number>) =>
  (await api.post('/customer/wishlist/sync', { vehicleIds })).data;
